export default function PageHeader({ eyebrow, title, subtitle }) {
    return (
        <header className="container-editorial pt-16 md:pt-24 pb-10 md:pb-14">
            {eyebrow && <p className="label-eyebrow text-primary">{eyebrow}</p>}
            <h1 className="font-serif text-5xl md:text-6xl leading-[1.02] tracking-tight mt-3 text-balance max-w-4xl">
                {title}
            </h1>
            {subtitle && (
                <p className="mt-5 text-lg md:text-xl text-stone-600 max-w-2xl leading-relaxed">
                    {subtitle}
                </p>
            )}
        </header>
    );
}
